import React, { FC, memo } from 'react';
import CloudinaryPhoto from '@minecraft.cloudinary-photo';
import { MediaType } from '../SummaryTypes';

type Props = {
  primaryPhoto: MediaType;
};

const SummaryPrimaryPhoto: FC<Props> = ({ primaryPhoto }) => {
  return (
    <CloudinaryPhoto
      type="lg"
      guid={primaryPhoto?.media?.guid}
      fileKey={primaryPhoto?.media?.fileKey}
      transformation={primaryPhoto?.media?.transformation}
      mediaStorageStatus={primaryPhoto?.media.mediaStorageStatus}
    />
  );
};

export default memo<Props>(SummaryPrimaryPhoto);
